@if (data) {
  <div class="icon">
    <span class="icon-circle">
      <mat-icon>priority_high</mat-icon>
    </span>
  </div>
  <div class="content">
    <span class="title">{{ "SNACKBAR.WARNING" | translate }}</span>
    <p [innerHTML]="data | translate"></p>
  </div>
}
